<template>
  <!-- 最外层卡片组件 -->
  <div class="card">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='scss' scoped>
  .card{
    width: 100%;   
    border-radius: 8px;    
    box-shadow: 0px 2px 12px 0px #EDEDED;
    overflow: hidden;
    background-color: #fff;
    position: relative;
    margin: 10px 0;
    border:1px solid#EDEDED;
  }
</style>